import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GeometryTypeConstants {

  readonly GeometryType = {
    "Critical Area": "492b52c039a246e2a4806a949f26a0b9",
    Plate: "51b97c79cf164388b36bf8edc326887c",
    Stiffener: "8a124b71ba374e08aaded3e7073c8bf0",
    "Face Plate": "573ef4493c3145128bb99d5daa131795",
    Bracket: "a6ecb8f533f64e7aacb10122adef0d9b",
    "Reference Line": "35d4384eae2e482abf11b5b81880cd5e",
    Tube: "b920c9fe5dca41d398c357c72858b6c6",
    Pipe: "b6d99dc151c345a3ba3ed2d1745e7449",
    Elbow: "cd19bf4136ce4b26bf9b3f2a346d830b",
    Nipple: "0e2ba6d3f76946eea680a72352a8c807",
    Olet: "e19b7a20b5ed45ef900236f6c135437b",
    Reducer: "ebbe293815874d9993696d514c3d349c",
    Tee: "43f2771601164eb28605febf638261d6",
    Valve: "8705084e3b604240a035a447d715cd91",
    Plug: "42c9f85c22cf49cdac608c533ebf5b60",
    Pipingflange: "1b82eac1880647efb9307d44b62ed5d5",
    Pipingblindflange: "0dffe261d8af4da0a0f53950c82f4e4c",
    Lateral: "2a4ca2e533c144b3b440af1a0b53ce46",
    Cap: "592aabb7924840699228fc98b69aaa51",
    Coupling: "93890d7675a64d0b8ec05fb419c9886a",
    Inlineinstrument: "bd90c224426042c4acdae59abcb1a848",
    Sleeve: "121494eaf52a4608abe25d4dc0da7bf2",
    Swage: "1dcf67ff47144261a0e839fba997e6f4",
    Hose: "46cbda4bfe42400289a66698252dfce6",
    Point: "15c2b057bc724c3c9b93a6166981f7d2",
    Connector: "bcb578fd317a4d37a4698e901e5805bc",
    Solid: "01860c9d45a34756a1be9533aad16487",
    Concrete: "d1537f8388504c40be9be1c9b322963f",
    Soil: "cd6e0347f33c49cda722b2552a4527cf",
    Beam: "055fc5dc1d134c57917073c2842a4f24",
  };


  getIdByName(name: string): string | undefined {
    return this.GeometryType[name];
  }

  getNameById(id: string): string | undefined {
    return Object.keys(this.GeometryType).find(key => this.GeometryType[key] === id);
  }

  getAllConstants(): { id: string, name: string }[] {
    return Object.entries(this.GeometryType).map(([name, id]) => ({ id, name }));
  }
  
  getFilteredConstants(filterList: string[]) {
    return this.getAllConstants().filter(item => filterList.includes(item.name))
  }
}


